import { Link } from "react-router-dom";
import React, { useState, Fragment } from "react";
import { SearchIcon, QuestionMarkCircleIcon } from "@heroicons/react/solid";
import { PlusCircleIcon, DotsHorizontalIcon } from "@heroicons/react/outline";
import Layout from "./../../components/Layout/Layout";
import UserServices from "../../services/UserServices";
import { useEffect } from "react";
import Paginate from "../../utils/Paginate";
import { Menu, Transition } from "@headlessui/react";
import fire from "./../../utils/Toastr";
import AccountServices from "../../services/AccountServices";
import { toast } from "react-toastify";

export default function UpgradeAccount() {
  const [user, setRequests] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [pageLength, setPageLength] = useState("");
  const [adminType, setAdminType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [exporting, setExporting] = useState(false);

  const listAllUpgradeRequest = async (search, status) => {
    const details = await AccountServices.upgradeAccounts(
      pageIndex,
      10,
      status,
      startDate,
      endDate,
      search
    );
    setRequests(details?.data?.result);
    console.log("results", details?.data?.result);
    setPageLength(details?.data?.result.length);
    setPageNumber(details?.data?.totalCount);
    setPageIndex(details?.data?.pageIndex);
    setPrev(details?.data?.hasPreviousPage);
    setPage(details?.data?.totalPages);
    setNextPage(details?.data?.hasNextPage);
  };

  const listUser = async () => {
    listAllUpgradeRequest(search, status);
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  };

  const searchUser = async (text) => {
    setSearch(text);
  };

  const exportAccount = async () => {
    // Show export in progress message
    setExporting(true);
    toast.success("Exporting data...");

    try {
      // Call the API
      const response = await AccountServices.exportAccount(
        pageIndex,
        10,
        status,
        startDate,
        endDate,
        search
      );

      if (response.status) {
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "AccountOfficers-Export.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        toast.success("Data exported successfully!");
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.error("Export failed:", error);
      toast.success("Export failed. Please try again.");
    } finally {
      setExporting(false);
    }
  };

  const searchUsers = async () => {
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    listAllUpgradeRequest(search, status);
  };

  useEffect(() => {
    listUser();
  }, [pageIndex]);

  const syncRequest = async () => {
    const res = await AccountServices.syncAccount();
    if (res.status) {
      console.log("res", res);
      toast.success("Account Synched successfully");
    }
  };
  return (
    <>
      <Layout
        title="Upgrade Requests"
        pageTag={"account"}
        current={"/user/upgrade"}
      >
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex justify-between">
                    <div className="flex">
                      <div className="mt-1 relative rounded-md shadow-sm">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                          <SearchIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                          />
                        </div>
                        <input
                          type="text"
                          name="user"
                          id="user"
                          onChange={(e) => searchUser(e.target.value)}
                          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                          placeholder="Search requests"
                        />
                        <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                          <div className="tooltip">
                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                            <span className="tooltiptext">
                              {" "}
                              <p>Search by Surname and Account number</p>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className=" mt-1 relative rounded-md shadow-sm ml-3">
                        <select
                          id="currency"
                          name="currency"
                          onChange={(e) => {
                            if (e.target.value == "sort") {
                              setStatus("");
                            } else if (e.target.value == "All") {
                              setStatus("");
                            } else {
                              setStatus(e.target.value);
                            }
                          }}
                          placeholder="Sort by"
                          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                        >
                          <option value={"sort"}>Sort by</option>
                          <option value={"All"}>All</option>
                          <option value={"Pending"}>Pending</option>
                          <option value={"Rejected"}>Rejected</option>
                          <option value={"Completed"}>Completed</option>
                        </select>
                      </div>

                      {/* Start Date Input */}
                      <div className="mt-1 ml-3 relative rounded-md shadow-sm">
                        <span className="bottom-10 absolute">From</span>
                        <input
                          type="date"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder="Start Date"
                        />
                      </div>

                      {/* End Date Input */}
                      <div className="mt-1 ml-3 relative rounded-md shadow-sm">
                        <span className="bottom-10 absolute">To</span>
                        <input
                          type="date"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                          placeholder="End Date"
                        />
                      </div>

                      <div className="mt-1 ml-4">
                        <button
                          onClick={searchUsers}
                          className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                          Search
                        </button>
                      </div>
                    </div>
                    {/* Export */}
                    <div className="mt-1 ml-4">
                      <button
                        onClick={exportAccount}
                        className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                      >
                        Export
                      </button>
                    </div>
                  </div>
                </div>

                <div className="flex items-end justify-end gap-5 py-4">
                  <div className="mt-1">
                    <button
                      onClick={syncRequest}
                      type="button"
                      className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                    >
                      <PlusCircleIcon className="w-4 mr-1.5" />
                      Sync Request
                    </button>
                  </div>
                </div>

                {user.length === 0 ? (
                  <div className="mt-8">
                    {" "}
                    No data available for these dates to show.{" "}
                  </div>
                ) : (
                  <>
                    <div className="mt-8 flex ">
                      <div className="-my-2 -mx-4 overflow-x-auto ">
                        <div className="inline-block min-w-full py-2 align-middle mb-20 ">
                          <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                              <thead>
                                <tr>
                                  <th
                                    scope="col"
                                    className="px-2 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Username
                                  </th>
                                  <th
                                    scope="col"
                                    className="min-w-[9rem] py-3.5 pl-5 pr-3 italic font-normal text-left text-sm text-gray-400"
                                  >
                                    First Name
                                  </th>

                                  <th
                                    scope="col"
                                    className="px-2 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Surname
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Email
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Phone Number
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    BVN
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    NIN
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Account Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Account Number
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Account Type
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Occupation
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Landmark
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Nearby Bustop
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Residential Address
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    State
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400"
                                  >
                                    <span className="sr-only">Action</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {user.map((person, i) => (
                                  <tr key={i} className="bg-gray-50">
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.userName}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.firstName}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.surname}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.emailAddress}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.phoneNumber}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.bvn}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.nin}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.accountName}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.accountNumber}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.accountType}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.occupation}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.majorLandmark}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.nearestBusStop}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.residentialAddress}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.state}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                      {person.accountUpgradeStatus}
                                    </td>
                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                      <Menu
                                        as="div"
                                        className="ml-3  flex-shrink-0"
                                      >
                                        <div>
                                          <Menu.Button className="  flex text-sm text-white">
                                            <span className="sr-only">
                                              Open user menu
                                            </span>
                                            <DotsHorizontalIcon className="w-8 text-gray-400" />
                                          </Menu.Button>
                                        </div>
                                        <Transition
                                          as={Fragment}
                                          enter="transition ease-out duration-100"
                                          enterFrom="transform opacity-0 scale-95"
                                          enterTo="transform opacity-100 scale-100"
                                          leave="transition ease-in duration-75"
                                          leaveFrom="transform opacity-100 scale-100"
                                          leaveTo="transform opacity-0 scale-95"
                                        >
                                          <Menu.Items className="origin-top-right absolute right-6 mt-2 w-40 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <Link
                                              to={`/customer/document?id=${person.userName}`}
                                              className="block py-2 px-5 text-sm text-gray-700 text-left"
                                            >
                                              View Document
                                            </Link>
                                          </Menu.Items>
                                        </Transition>
                                      </Menu>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Paginate
                      nextPage={nextPage}
                      pageIndex={pageIndex}
                      totalCount={pageNumber}
                      totalPages={totalPage}
                      prevPage={prevPage}
                      setPageIndex={setPageIndex}
                    />
                  </>
                )}
              </div>
            </div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
